export const ProductsData = state => state.products.data;
export const ProductsLoaded = state => state.products.loaded;
export const ProductsFailed = state => state.products.failed;
export const CategoryProducts = (state, categoryId) => categoryId && state.products.data.filter(item => item.parentId === categoryId) || []

